<template>
  <div class="main-container-wrap">
    <div class="main-container" style="padding-top:20px">
      <div class="contentArea">
        <!-- 基础信息 -->
        <el-descriptions title="异议信息" :column="2" border  labelClassName="label_class2">
          <el-descriptions-item label="异议企业名称" :span="2">{{info.goldenSeedCompany?.companyName}}</el-descriptions-item>
          <el-descriptions-item label="统一社会信用代码" :span="2">{{info.goldenSeedCompany?.uscc}}</el-descriptions-item>
          <el-descriptions-item label="入库时间" :span="2">{{info.goldenSeedCompany?.storageTime}}</el-descriptions-item>
          <el-descriptions-item
            label="内容描述"
            :span="2"
          >{{info.objecttionReason}}</el-descriptions-item>
          <el-descriptions-item label="附件" :span="2">
            <div v-if="info.fileList?.length">
                <FileUploadView v-model="info.fileList" disabled :customTip="' '"></FileUploadView>
              <!-- <el-image
                v-for="item in info.fileList"
                :key="item.fileUrl"
                style="width: 200px; height: 200px"
                :src="item.fileUrl"
                :preview-src-list="[item.fileUrl]"
              ></el-image> -->
            </div>
          </el-descriptions-item>
        </el-descriptions>
        <!-- <div style="text-align: center;margin-top:20px">
              <el-button @click="close">关闭</el-button>
            </div> -->
      </div>
    </div>
  </div>
</template>
  
  <script>
  import FileUploadView from "@/components/FileUploadView"
import { objectView } from "@/api/index";
export default {
  name: "objectView",
  components:{FileUploadView},
  data() {
    return {
      info: {}
    };
  },
  created() {
    objectView(this.$route.query.id).then(res => {
      this.info = res.data;
    });
  },
  methods: {
    close(){
        window.close()
    }
  }
};
</script>
  
  <style>
.container {
  padding: 20px 0;
}
.main {
  width: 1200px;
  min-height: calc(100vh - 226px);
  margin: 0px auto;
  background-color: #fff;
  border-radius: 10px;
  box-sizing: border-box;
  padding: 20px;
}
.headTitle {
  padding: 5px 20px;
  border-left: 4px solid #409eff;
  font-size: 20px;
  margin-bottom: 50px;
}
.formBox {
}
.contentArea {
  min-height: calc(100vh - 228px);
  background-color: #fff;
  margin-bottom: 20px;
  padding: 30px;
  border-radius: 4px;
}

</style>